import { post, get } from '../../../components/hooks/apiFetch';

export const useRetellingApi = () => {
    const submitRetellingRequest = async (filesWithFormats, comment = '', startTime = '') => {
        comment ??= '';
        const formData = new FormData();
        filesWithFormats.forEach((item, index) => {
            formData.append(`Files[${index}].File`, item.file, item.file.name);
            formData.append(`Files[${index}].OutputFormat`, item.outputFormat);
            if (item.templateName && item.templateName.trim() !== '') {
                formData.append(`Files[${index}].TemplateName`, item.templateName);
            }
        });

        formData.append("Options.Comment", comment.trim());
        formData.append("Options.StartTime", startTime);

        const result = await post("/api/retelling", formData);

        return {
            id: result.id,
            identifier: result.identifier
        };
    };

    const cancelRetellingTask = async (inputIdentifier) => {
        await get(`/api/retelling/cancel/${encodeURIComponent(inputIdentifier)}`);
        return true;
    };

    return { submitRetellingRequest, cancelRetellingTask };
};